:host {
  display: block;
}

accept-or-counteroffer [role='modalCard'] {
  width: 650px;
}
